import { GETTERS } from "./getters";
import { P_MUTATIONS, MUTATIONS } from "./mutations";
import { loadDictionary } from "@/api/dictionary";
import { CardSave, CardList, CardGet } from "@/api/card";
import { save as saveFile, get as loadFile, detach } from "@/api/file";
import { signIn } from "@/api/user";

export const ACTIONS = {
  LOAD_DICTIONARY: "LOAD_DICTIONARY",
  LOAD_CARDS: "LOAD_CARDS",
  SAVE_CARD_DATA: "SAVE_CARD_DATA",
  LOAD_CARD_DATA: "LOAD_CARD_DATA",
  SAVE_CARD_FILES: "SAVE_CARD_FILES",
  LOAD_CARD_FILE: "LOAD_CARD_FILE",
  DETACH_CARD_FILE: "DETACH_CARD_FILE",
  LOAD_COMPARED_CARDS_DATA: "LOAD_COMPARED_CARDS_DATA",
  SET_FILE_LOADING: "SET_FILE_LOADING",
  USER_SIGNIN: "USER_SIGNIN",
};

export const actions = {
  [ACTIONS.LOAD_DICTIONARY]({ commit, getters }) {
    if (getters[GETTERS.IS_LOADING]) {
      return;
    }
    commit(P_MUTATIONS.SET_LOADING, true);
    const dictionary = loadDictionary();
    commit(P_MUTATIONS.SET_DICTIONARY, dictionary);
    commit(P_MUTATIONS.SET_LOADING, false);
  },

  async [ACTIONS.SAVE_CARD_DATA]({ state, commit, getters }, id) {
    if (state.isSaving || !getters[GETTERS.CARD_IS_CHANGED]) {
      return;
    }

    commit(P_MUTATIONS.SET_SAVING, true);
    /// expectedLevel надо отправлять всегда целиком
    const expectedLevel = getters[GETTERS.CARD_DATA].expectedLevel;
    const uNumber = getters[GETTERS.CARD_DATA].uNumber;

    const { data, connector_state } = await CardSave({
      ...state.changes,
      id,
      expectedLevel,
      uNumber,
    });

    if (!connector_state.isError) {
      const card_new = Object.assign({}, getters[GETTERS.CARD_DATA], data);
      commit(P_MUTATIONS.SET_CARD_DATA, card_new);
      commit(P_MUTATIONS.UPDATE_CARD_IN_CARDS, { ...card_new, id });
    } else {
      commit(MUTATIONS.NOTIFICATION_PUSH, {
        status: connector_state.status,
        text: connector_state.text,
        type: "error",
      });
    }
    commit(P_MUTATIONS.SET_SAVING, false);
  },

  async [ACTIONS.LOAD_CARDS]({ state, commit }, params) {
    if (state.isLoading) {
      return;
    }

    commit(P_MUTATIONS.SET_LOADING, true);
    const { data, connector_state } = await CardList(params);

    if (!connector_state.isError) {
      commit(P_MUTATIONS.SET_CARDS, data);
    } else {
      commit(MUTATIONS.NOTIFICATION_PUSH, {
        status: connector_state.status,
        text: connector_state.text,
        type: "error",
      });
    }
    commit(P_MUTATIONS.SET_LOADING, false);
  },

  async [ACTIONS.LOAD_COMPARED_CARDS_DATA]({ commit, getters }) {
    if (getters[GETTERS.IS_LOADING]) {
      return;
    }
    const params = {
      idList: getters[GETTERS.COMPARED_CARDS].map((item) => +item),
    };

    commit(P_MUTATIONS.SET_LOADING, true);
    const { data, connector_state } = await CardList(params);

    if (!connector_state.isError) {
      commit(P_MUTATIONS.SET_COMPARED_CARD_DATA, data);
    } else {
      commit(MUTATIONS.NOTIFICATION_PUSH, {
        status: connector_state.status,
        text: connector_state.text,
        type: "error",
      });
    }
    commit(P_MUTATIONS.SET_LOADING, false);
  },

  async [ACTIONS.LOAD_CARD_DATA]({ commit, getters }, id) {
    if (getters[GETTERS.IS_LOADING]) {
      return;
    }

    commit(P_MUTATIONS.SET_LOADING, true);
    const { data, connector_state } = await CardGet(id);
    if (!connector_state.isError) {
      commit(P_MUTATIONS.SET_CARD_DATA, data);
    } else {
      commit(MUTATIONS.NOTIFICATION_PUSH, {
        status: connector_state.status,
        text: connector_state.text,
        type: "error",
      });
    }

    commit(P_MUTATIONS.SET_LOADING, false);
  },

  async [ACTIONS.SAVE_CARD_FILES]({ state, commit, getters }, fieldName) {
    if (state.isSaving || !getters[GETTERS.CARD_IS_CHANGED]) {
      return;
    }

    commit(P_MUTATIONS.SET_SAVING, true);
    const data = getters[GETTERS.CARD_DATA];
    const changes = state.changes[fieldName].slice();
    let update;

    for (let item of changes) {
      try {
        const response = await saveFile(
          item.file,
          fieldName,
          data.id,
          data.uNumber
        );
        update = {
          ...item,
          ...response.data,
          message: "",
        };
        commit(P_MUTATIONS.SET_CARD_FILE, { fieldName, update });
      } catch (error) {
        console.log(error);
      }
    }
    commit(P_MUTATIONS.SET_SAVING, false);
  },

  async [ACTIONS.LOAD_CARD_FILE]({ commit, dispatch }, { uuid }) {
    commit(P_MUTATIONS.SET_FILE_LOADING, true);

    const progress = (progressEvent) => {
      if (
        progressEvent.currentTarget.readyState === 4 ||
        progressEvent.loaded === progressEvent.total
      ) {
        // eslint-disable-next-line
          //debugger
        dispatch(ACTIONS.SET_FILE_LOADING, false);
        // commit(SET_FILE_LOADING, false);
      }
    };

    const { response, connector_state } = await loadFile({ uuid }, progress);

    if (!connector_state.isError) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      // eslint-disable-next-line
          //debugger

      const splitted = response.headers["content-disposition"].split("UTF-8''");
      link.setAttribute("download", decodeURIComponent(splitted[1]));

      document.body.appendChild(link);
      link.click();
      commit(P_MUTATIONS.SET_FILE_LOADING, false);
    } else {
      commit(MUTATIONS.NOTIFICATION_PUSH, {
        status: connector_state.status,
        text: connector_state.text,
        type: "error",
      });
      commit(P_MUTATIONS.SET_FILE_LOADING, false);
    }
  },

  async [ACTIONS.DETACH_CARD_FILE]({ commit }, { fieldName, uuid, cardId }) {
    const { connector_state } = await detach({ uuid, cardId });

    if (!connector_state.isError) {
      commit(P_MUTATIONS.DETACH_CARD_FILE, { fieldName, uuid });
    } else {
      commit(MUTATIONS.NOTIFICATION_PUSH, {
        status: connector_state.status,
        text: connector_state.text,
        type: "error",
      });
    }
  },

  async [ACTIONS.SET_FILE_LOADING]({ commit }, payload) {
    await commit(P_MUTATIONS.SET_FILE_LOADING, payload);
  },

  async [ACTIONS.USER_SIGNIN]({ commit }, { username, password }) {
    commit(P_MUTATIONS.SET_LOADING, true);
    const { data, connector_state } = await signIn({ username, password });

    if (!connector_state.isError) {
      commit(P_MUTATIONS.SET_USER, { ...data });
    } else {
      commit(MUTATIONS.NOTIFICATION_PUSH, {
        status: connector_state.status,
        text: connector_state.statusText,
        type: "error",
      });
    }
    commit(P_MUTATIONS.SET_LOADING, false);
  },
};
